import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
@Component({
  selector: 'app-d-title',
  templateUrl: './d-title.component.html',
  styles: [``],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DTitleComponent),
      multi: true
    }
  ]
})
export class DTitleComponent extends DynamicComponentBase {
  static KEY = 'd-title';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.paddingLeft !== 'string') {
      config.paddingLeft = '10px';
    }
    if (typeof config.fontSize !== 'string') {
      config.fontSize = '18px';
    }
    if (typeof config.color !== 'string') {
      config.color = '#000000';
    }
    if (typeof config.weight !== 'number') {
      config.weight = '400';
    }
  }
}
